import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = { key: 1 }

import type { PropType } from "@vue/runtime-core";
import { computed } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseButton',
  props: {
  title: {
    type: String,
  },
  color: {
    type: String as PropType<
      | "primary"
      | "white"
      | "transparent-white"
      | "transparent-black"
      | "transparent-primary"
      | "grey"
    >,
    default: "primary",
  },
  size: {
    type: String as PropType<"extra-large" | "large" | "medium" | "small">,
    default: "medium",
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  loading: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props;

const classes = computed(() => {
  return [
    props.color,
    props.disabled || props.loading ? "disabled" : "",
    props.size,
    props.size === "large" || props.size === "extra-large"
      ? "button-large"
      : "button-medium",
  ];
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["base-button color-basic", classes.value]),
    disabled: __props.disabled
  }, [
    (_ctx.$slots.default)
      ? _renderSlot(_ctx.$slots, "default", { key: 0 })
      : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(__props.title), 1))
  ], 10, _hoisted_1))
}
}

})